module.exports = __webpack_public_path__ + "static/media/img_7.2988ad7a.png";